import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, {useRef} from 'react'
import './styles/master.css'
import Login from "./components/pre_login/login";
import Verify from "./components/post_login/verify";
import SelectProducts from "./components/post_login/selectProducts"
import Summary from "./components/post_login/summary"
import ViewTransactions from "./components/post_login/ViewTransactions"
import ReportTemplate from "./components/post_login/templates/ReportTemplate";
import ErrorPage from "./components/common/ErrorPage";
import RecoverPassword from "./components/pre_login/RecoverPassword"
import LoginComponent from "./components/pre_login/layout2/LoginComponent"
import { useSelector ,useDispatch } from "react-redux";
// import { Capacitor } from '@capacitor/core';
// import { StatusBar } from '@capacitor/status-bar'
import { useState, useEffect  } from "react";
import { addUserDetails } from './store/actions/saveUserCredentials'
import { AppStateProvider } from "./contexts/AppStateContext";
import { validSession } from "./components/common/Utils";
import { ThemeProvider } from './styles/ThemeContext'
import themeData from './styles/theming.json';
import ServiceDashboard from "./components/post_login/ServiceDashboard";
import SchoolFeePayment from "./components/post_login/SchoolFeePayment";
import SchoolFeeSummary from "./components/post_login/SchoolFeeSummary";
import AdminDashboard from "./components/post_login/AdminDashboard";
import ServiceDetails from "./components/post_login/ServiceDetails";
function App() {
  const userData = useSelector(state => state.userCredentials)
  const cart = useSelector(state => state.cart)
  const dispatch = useDispatch();
  const boxRef = useRef();
  let logtime = userData.logtime ? userData.logtime : 0;
  const [currentTheme, setCurrentTheme] = useState("murangaCounty");
  useEffect(() => {
    window.onclick = (event) => {
      if (event.target.contains(boxRef.current) && event.target !== boxRef.current) {
      } else {
        if (!validSession(logtime)) {
             dispatch(addUserDetails({}));
        }
      }
    }
  }, [logtime]);
  const themes = themeData[currentTheme];
  return (
    <div className="App" ref={boxRef}>
      <ThemeProvider initialTheme={themes}>
        <AppStateProvider>
          <BrowserRouter>
            {Object.keys(userData).length <= 0 ?
              <Routes>
                <Route path="*" exact element={<LoginComponent />} />
                <Route path="/" exact element={<LoginComponent />} />
                <Route path="/login-screen1" exact element={<Login />} />
                <Route path="/login" exact element={<LoginComponent />} />
                <Route path="/error" exact element={<ErrorPage />} />
                <Route path="/recover-password" element={<RecoverPassword />} />
              </Routes>
              :
              userData.Type == "ADMIN" ?
                <Routes>
                  <Route path="*" exact element={<AdminDashboard />} />
                  <Route path="/" exact element={<AdminDashboard />} />
                  <Route path="/admin-dashboard" element={<AdminDashboard />} />
                  <Route path="/service-details" element={<ServiceDetails />} />
                </Routes>
                :
                <Routes>
                  <Route path="/pdf" exact element={<ReportTemplate />} />
                  <Route path="*" exact element={<ErrorPage />} />
                  <Route path="/" element={<Verify />} />
                  <Route path="/login-screen1" element={<Login />} />
                  <Route path="/login" exact element={<LoginComponent />} />
                  <Route path="/verify" element={<Verify />} />
                  <Route path="/school-fees" element={<SchoolFeePayment />} />
                  <Route path="select-products" element={<SelectProducts />} />
                  <Route path="summary" element={<Summary />} />
                  <Route path="/school-summary" element={<SchoolFeeSummary />} />
                  <Route path="transactions" element={<ViewTransactions />} />
                  <Route path="/error" exact element={<ErrorPage />} />
                  <Route path="/recover-password" element={<RecoverPassword />} />
                  <Route path="/service-dashboard" element={<ServiceDashboard />} />
                </Routes>
            }
          </BrowserRouter>
        </AppStateProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
